module.exports = __webpack_public_path__ + "static/media/AWS-Service-Catalog.1ed0286e.svg";